var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app","dark":false}},[_c('router-view'),_c('NotificacionComponent'),_c('CargandoComponent'),_c('LoginFakeComponent',{attrs:{"active":_vm.openModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }